module.exports = __webpack_public_path__ + "img/yunnan.4b7941fc.png";